// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 608) return "static/chunks/608-95f72da7ab199217.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"62":"c1715d558eb7dc53","334":"669a261380374549","381":"409d3ae321929fa4","850":"9094ce8c75d867bf","893":"c2e23af562e612a0"}[chunkId] + ".js";
};